<template>
  <div>
  <div class="topnav">
    <div class="topMiddle">
      <router-link :to="navTo('', '#home')" class="logo-link" @click.native="handleHashNavClick('', '#home', $event)">
        <img src="@/assets/imgs/pc/topNav/topNav.png" alt="Arcanite home" class="logo">
      </router-link>
      <div class="topbtn">
        <div class="product">
          <div class="topnav_btn">{{ $t("topNav.products") }}
          </div>
		  
          <div class="hover"></div>
          <div class="down" style="">
            <div class="downDrop">
              <div class="col" style="border-right:1px solid #e6ebf2">
                <router-link :to="navTo('/Arcanite')" class="line">
                  <img src="../../assets/imgs/pc/topNav/p1.png" alt="">
                  <div class="text">
                    <p class="itemTitle">{{ $t("topNav.arcanite") }}</p>
                    <p>{{ $t("topNav.mobile_focused") }}</p>
                  </div>
                </router-link>
                <router-link :to="navTo('/ArcaniteConnect')" class="line">
                  <img src="../../assets/imgs/pc/topNav/p2.png" alt="">
                  <div class="text">
                    <p class="itemTitle">
                      {{ $t("topNav.arcanite_connect") }}
                    </p>
                    <p>{{ $t("topNav.manage_your_sales_operations") }}</p>
                  </div>
                </router-link>
                <router-link :to="navTo('/ArcanitePartners')" class="line">
                  <img src="../../assets/imgs/pc/topNav/p3.png" alt="" >
                  <div class="text">
                    <p class="itemTitle">{{ $t("topNav.arcanite_partners") }}</p>
                    <p>{{ $t("topNav.connect_developers_agents") }}</p>
                  </div>
                </router-link>
              </div>
              <div class="col">
                <!-- <div class="line" @click="goRouter('/Equimate')">
                  <img src="../../assets/imgs/pc/topNav/p5.png" alt="">
                  <div class="text">
                    <h1>Equimate</h1>
                    <p>Help Aussies buyers get into their dream home</p>
                  </div>
                </div> -->
                <router-link :to="navTo('/DragonVR')" class="line">
                  <img src="../../assets/imgs/pc/topNav/p4.png" alt="">
                  <div class="text">
                    <p class="itemTitle">{{ $t("topNav.dragonVR") }}</p>
                    <p>{{ $t("topNav.bringing_off_the_plan") }}</p>
                  </div>
                </router-link>
                <router-link :to="navTo('/Marketplace')" class="line">
                  <img src="../../assets/imgs/pc/topNav/p6.png" alt="">
                  <div class="text">
                    <p class="itemTitle">{{ $t("topNav.project_marketplace") }}</p>
                    <p>{{ $t("topNav.expand_your_network_discover") }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="product">
          <router-link :to="navTo('/Features')" class="topnav_btn">{{ $t("topNav.features") }}
            <!-- <span class="active" :class="active==1?'activeShow':''"></span> -->
          </router-link>
          <div class="hover"></div>
        </div>
        <div class="product">
          <router-link :to="navTo('/Pricing')" class="topnav_btn">{{ $t("topNav.pricing") }}
            <!-- <span class="active" :class="active==2?'activeShow':''"></span> -->
          </router-link>
          <div class="hover"></div>
        </div>
        <div class="product">
          <router-link :to="navTo('/Blogs')" class="topnav_btn">{{ $t("topNav.blogs") }}
            <!-- <span class="active" :class="active==3?'activeShow':''" ></span> -->
          </router-link>
          <div class="hover"></div>
        </div>
        <div class="product">
          <router-link :to="navTo('/contact')" class="topnav_btn">{{ $t("topNav.contact_us") }}
            <!-- <span class="active" :class="active==3?'activeShow':''" ></span> -->
          </router-link>
          <!-- <div class="topnav_btn" >&nbsp;
          </div> -->
          <div class="hover"></div>
        </div>
        <div class="totalButtonSection">
          <div v-if="isID" class="idWhatsApp" tabindex="0" role="button" @click="callWhatsApp" @keyup.enter="callWhatsApp" @keyup.space="callWhatsApp">
            <img src="./../../assets/imgs/pc/homepage/Arc-log-whatsappNav.png" class="whatsAppIcon" alt="Contact us on WhatsApp"/>
          </div>
          <div class="btnArea">
            <!-- <a v-if="!isID" onclick="Calendly.showPopupWidget('https://meetings.hubspot.com/william463?embed=true');
            return false;"> -->
            <a v-if="!isID" >
              <button class="btn" :class="[isID?'IDbtn':'']" @click="handleDemoBooking(true)">{{ $t("pricing.free_demo") }}<img src="./../../assets/imgs/pc/homepage/p12Vector.png" class="vector"></button>
            </a>
            <!-- <a v-else onclick="Calendly.showPopupWidget('https://calendly.com/erni-yap');
            return false;"> -->
            <a v-else >
              <button class="btn" :class="[isID?'IDbtn':'']" @click="handleDemoBooking(true)">{{ $t("pricing.free_demo") }}<img src="./../../assets/imgs/pc/homepage/p12Vector.png" class="vector"></button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-button class="Rectangle" v-if="isRectangle" @click="handleBookBtn">
      <span> Book a demo</span>
    </el-button> -->
  </div>
  <book-demo v-if="showBookingDialog" :show="showBookingDialog" @update:show="handleDemoBooking"></book-demo>
</div>
</template>
<script>
export default {
  props: ['active', 'istop', 'isRectangle'],
  data() {
    return {
      isID:false,
      userId: "",
      name: "Unknown User",
      email: "",
      appid:"uu6ddns6",
      showBookingDialog: false
    }
  },
  created() {
    if(localStorage.getItem('country')=="id"){
      this.isID=true;
    }else{
      this.isID=false;
    }
    this.userId = 'arcweb' + new Date().getTime() + this.MathRand();
    if (location.pathname.includes('/bookdemo')) {
      this.showBookingDialog = true;
    }
    if (location.pathname.includes('/FB')) {
      localStorage.setItem('socialmedia', 'FB')
    } else {
      localStorage.setItem('socialmedia', '')
    }
  },
  mounted() {
    if (window.Intercom) {
      console.info('Intercom loading');
      window.Intercom('boot', { app_id: 'uu6ddns6' });
    } else {
      console.error('Intercom not loaded yet');
    }
    // if(!this.isID && window && window.HubSpotConversations && window.HubSpotConversations.widget){
    //   window.HubSpotConversations.widget.remove(); 
    // }
          
  },
  watch: {
    // email(email) {
    //     Intercom("update",{ email:this.email })
    // },
    // name(name) {
    //     Intercom("update",{ name:this.name })
    // },
    // userId(user_id) {
    //     Intercom("update",{ user_id:this.userId })
    // },
  },
  methods: {    
    handleDemoBooking(open = false) {
      const rawpath = this.$route.path;
      const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      if (open) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } else {
        history.replaceState({}, '', base || '/');
      }
      this.showBookingDialog = open;
    },
    callWhatsApp(){
      let data = "https://api.whatsapp.com/send?phone=6281319386791"
      window.open(data,'_system')
    },
    MathRand() {
      var Num = "";
      for (var i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      return Num
    },
    goRouter(path, section) {
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');

      if (this.$route.path !== newPath) {
        this.$router.push({
          path: newPath,
          hash: section
        });
      } else if (this.$route.path == newPath && section) {
        const isFB = location.pathname.includes('/FB');
        history.replaceState({}, '', isFB ? `/FB${section}` : section);
        this.$emit('navigateScroll', section)
      }
    },
    navTo(path, section) {
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');
      return { path: newPath, hash: section };
    },
    handleHashNavClick(path, section, event) {
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');
      if (this.$route.path === newPath) {
        event.preventDefault();
        const isFB = location.pathname.includes('/FB');
        history.replaceState({}, '', isFB ? `/FB${section}` : section);
        this.$emit('navigateScroll', section);
      }
    },
    handleClickContactUS() {
      if(this.isID){
        this.callWhatsApp()
      }else if(!this.isID){
        // window.HubSpotConversations.widget.open(); 
      }
    },

  },
    components: {
    "book-demo": () => import("./BookDemo/Index.vue")
  },

}
</script>
<style lang="scss" scoped>
.topnav {
  width: 100%;
  height: 90px;
  position: fixed;
  // z-index: 89; // 好像有问题？
  top: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  display: inline-block;
  text-align: center;
  // border: 1px solid #e6ebf2;
  border-bottom: 1px solid #e6ebf2;
  .topMiddle {
    width: 1210px;
    display: inline-block;
    position: relative;
    text-align: center;
    height: 90px;
    vertical-align: center;
    .logo-link {
      text-decoration: none;
    }
    .logo-link:focus-visible {
      outline: 2px solid #1890ff;
      outline-offset: 2px;
    }
    .logo {
      position: absolute;
      left: 0;
      width: 226px;
      // height: 58px;
      margin-right: 30px;
      margin-top: 8px;
    }
    .logo:hover{
      cursor: pointer;
    }
    .topbtn {
      position: absolute;
      right: -50px;
      height: 100%;
      display: flex;
      vertical-align: center;
      .topnav_btn {
        position: relative;
        // width: 68px;
        height: 55px;
        margin: 32px 10px 0 50px;
        // padding-bottom: 24px;
        flex-grow: 0;
        font-family: Poppins;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: center;
        color: #062440;
        display: inline-block;
        cursor:pointer;
        text-decoration: none;
      }
      .topnav_btn:focus-visible, .idWhatsApp:focus-visible, .logo:focus-visible {
        outline: 2px solid #1890ff;
        outline-offset: 2px;
      }
      .product:hover .hover {
        display: block;
      }
      .hover{
        display: none;
        width: calc(100% - 45px);
        margin-left: 44px;
        height: 6px;
        border-top: 3px solid #1890ff;
        border-radius: 3px;
      }
      .product {
        height: 100%;
        flex-grow: 0;
        font-family: Poppins;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: center;
        color: #062440;
        display: inline-block;
        position: relative;
      }
    }
  }
  .down {
    z-index: 99;
    width: 100vw;
    height: 284px;
    position: fixed;
    background-color: #fff;
    display: none;
    top: 90px;
    left: 0;
    border: 1px solid #e6ebf2;
  }
  .product:hover .down {
    display: block;
    // border: 1px solid #e6ebf2;
  }
  .down:hover {
    display: block;
  }
  .downDrop {
    width: 1210px;
    // border-top: 1px solid #e6ebf2;
    height: 284px;
    background-color: #fff;
    display: flex;
    margin: auto;
    .col {
      margin: 20px 10px 20px 20px;
      // width: 340px;
      padding-right: 20px;
      // height: 100%;
      .line {
        // margin: 10px 0 10px 0;
        padding: 10px;
        margin-bottom: 10px;
        // width: 328px;
        display: flex;
        text-decoration: none;
        color: inherit;
        img {
          width: 48px;
          height: 48px;
          border-radius: 5px;
          background-color: #f4f4f4;
        }
        .text {
          // width: 200px;
          height: 48px;
          margin: 0px 0 0 20px;
          display: inline;
          .itemTitle {
            margin: 0;
            font-family: Poppins-SemiBold;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.4;
            letter-spacing: normal;
            text-align: left;
            color: #062440;
          }
          p {
            font-family: Poppins;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #062440;
          }
        }
      }
      .line:focus-visible {
        border-radius: 5px;
        outline: 2px solid #1890ff;
        outline-offset: 2px;
      }
      .line:hover {
        border-radius: 5px;
        background: #eef7ff;
        cursor: pointer;
      }
    }
  }
  .totalButtonSection{
    display: flex;
    flex-direction: row;
    margin-left:180px;
    // justify-content: center;
    align-items: center;
    height: 87px;
    // margin: 32px 10px 0 50px;
    // width: fit-content;
    .idWhatsApp{
      .whatsAppIcon{
        cursor: pointer;
        width: 32px;
        height:32px;
      }
    }
  }

  .btnArea {
    margin-left: 30px;
    margin-right: 20px;
    display: inline-block;
  }
  .btn {
    width: 175px;
    height: 42px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    vertical-align: centre;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border-radius: 5px;
    background-color: #1890ff;
    flex-grow: 0;
    font-family: Poppins-Bold;
    font-size: 16px;
    //font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
	  white-space:nowrap;
    .vector {
      width: 22px;
      height: 22px;
    }
  }
  .IDbtn{
    width: 193px;
  }
  .btn:hover{
     background-color: #096dd9;
  }
  .btn:active{
    background-color: #0757ae;
  }
}
</style>